import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const users = [
	{
		avatr: 'https://web-data.zmlearn.com/image/hWCkSwxU2NTLxAkCv5n7oB/touxiang1%402x.png',
		name: 'Britney',
		date: 'Jul 2, 2021',
		text: `A brilliant session and it's worthy. Love it! \n Cathrine, my History teacher is flexible with time, even on short notice.
		 My history grade has reached A within 6 months. Overall, very happy with the teacher and the company!`,
	},
	{
		avatr: 'https://web-data.zmlearn.com/image/5bKM1B9KXCVf7RBmp5gxku/touxiang2%402x.png',
		name: 'Kaly',
		date: 'May 30, 2021',
		text: `	A tutor has impacts on a student's lifetime. So many thanks to my daughter's Chemistry tutor.
		He gave her many chances to express herself and this definitely developed her confidence. If she gets something wrong,
		the tutor will make a timely correction with full patience.`,
	},
	{
		avatr: 'https://web-data.zmlearn.com/image/9aMepFVsFMxbPz3xdkAXWB/touxiang3%402x.png',
		name: 'Daniel',
		date: 'May 15, 2021',
		text: `My son is extremely satisfied with AirClass and we highly recommend it. You know what, he just got an A* in Maths! That's
		marvelous and we can't even believe it because his predicted grade was C. So, it turns out we've found a perfect platform! It
		couldn’t be better.`,
	},
];
/**
 *	学生评价模块
 * @returns
 */
export default function AppraisalBox() {
	return (
		<div className={cx('appraisal-block')} id="form-next">
			<Section>
				<div className={cx('circle')} />
				<h3 className={cx('block-title', 'appraisal-title')}>91% of students improved their grades!</h3>
				<div className={cx('star-comment')}>
					<div className={cx('star-num')}>
						<div className={cx('stars')}>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
							<img
								loading="lazy"
								className={cx('star')}
								src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
								alt="star"
							/>
						</div>
						<span>
							<b>5</b>/5
						</span>
					</div>
					<div className={cx('comment-num')}>999+ comments</div>
				</div>
				<div className={cx('appraisal-list', 'scroll-view')}>
					{users.map((item, idx) => {
						return (
							<div className={cx('appraisal-item')} key={idx}>
								<header className={cx('item-hd')}>
									<div className={cx('user')}>
										<img loading="lazy" src={item.avatr} alt={item.name} />
										<span>{item.name}</span>
									</div>
									<span className={cx('time')}>{item.date}</span>
								</header>
								<div className={cx('stars')}>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
									<img
										loading="lazy"
										className={cx('star')}
										src="https://web-data.zmlearn.com/image/nX6uLPuHuVcB6kKoXdMgE/star%402x.png"
										alt="star"
									/>
								</div>
								<div className={cx('content')}>{item.text}</div>
							</div>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
